import { createContext } from "react";

interface WizardDataFormContextProps {
  handleTabErrors:                    (errorFields: any[], tabPrefix: string[], tabName: string) => void
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);